import PazientiList from "./components/PazientiList.vue";
import PazientiEdit from "./components/PazientiEdit.vue";
import PazientiProgettiList from "./pages/PazientiProgettiList.vue";
import PazientiProgettiViewPage from "./pages/PazientiProgettiViewPage.vue";

export default {
    PazientiList,
    PazientiEdit,
    PazientiProgettiList,
    PazientiProgettiViewPage
};
